export const AUDIT_STATUS = {
  0: "未审核",
  1: "已通过",
  2: "未通过",
};

export const AUDIT_PROCESS = {
  0: "warning",
  1: "success",
  2: "error",
};

export const AUDIT_OPTIONS = [{ value: "", label: "全部状态" }].concat(
  Object.keys(AUDIT_STATUS).map((key) => ({
    value: key,
    label: AUDIT_STATUS[key],
  }))
);
